import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {labels} from '../../../util/utils';
import Utility from '../../../util/utilityfunctions';
import {v4 as uuidv4} from 'uuid';

const ResourceWithLink = ({className, placeholder, onPlaceholderClickConfig}) => {
	return (
		<StyledResourceWithLink key={uuidv4()} className={`StyledResourceWithLink ${className}`}>
			{Utility.createClickableText(placeholder, onPlaceholderClickConfig)}
		</StyledResourceWithLink>
	);
};

ResourceWithLink.propTypes = {
	placeholder: PropTypes.string,
	onPlaceholderClickConfig: PropTypes.objectOf(PropTypes.func)
};

ResourceWithLink.defaultProps = {
	className: 'no-data-placeholder',
	placeholder: labels.noInformationAvailable
};

export default ResourceWithLink;

const StyledResourceWithLink = styled.section`
	display: block;
	.createClickableTextLink {
		cursor: pointer;
		font-size: var(--px-14);
		font-weight: 400;
		color: var(--blue-600)!important;
		padding: 0 var(--px-3);
		display: inline-flex;
	}
	.createRichTextElementSpanWrapper {
		font-size: var(--px-14);
	}
`;
